export default 'tenant-list'
